import type { FC } from 'react'

export interface JobStatusProps {
  status: string
}

export const JobStatus: FC<JobStatusProps> = ({ status }) => {
  return <span>{status}</span>
}
